export default function formatNumber(value, decimal) {
  const val = Number(value).toFixed(decimal)
  const result = val.toString().replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.')

  return result
}
